"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseAuthService = void 0;
const app_1 = __importDefault(require("firebase/app"));
require("firebase/auth");
class FirebaseAuthService {
    constructor(firebaseConfig) {
        if (!firebaseConfig || typeof firebaseConfig !== "object" || !firebaseConfig.apiKey) {
            throw new Error("FirebaseAuthService: valid config with apiKey is required. Check window.config.FIREBASE_AUTH_CONFIG.");
        }
        app_1.default.initializeApp(firebaseConfig);
        if (firebaseConfig.emulatorHost) {
            app_1.default.auth().useEmulator(`http://${firebaseConfig.emulatorHost}`);
        }
    }
    static getInstance(firebaseConfig) {
        if (!FirebaseAuthService.instance) {
            FirebaseAuthService.instance = new FirebaseAuthService(firebaseConfig);
        }
        return FirebaseAuthService.instance;
    }
    async registerUser(email, password) {
        try {
            return await app_1.default.auth().createUserWithEmailAndPassword(email, password);
        }
        catch (err) {
            throw Error(err.message || "Something went wrong during registration.");
        }
    }
    async setAuthPersistence(rememberMe) {
        try {
            const persistence = rememberMe ? app_1.default.auth.Auth.Persistence.LOCAL : app_1.default.auth.Auth.Persistence.SESSION;
            await app_1.default.auth().setPersistence(persistence);
        }
        catch (err) {
            throw Error(err.message || "Something went wrong while configuring sign-in persistence.");
        }
    }
    async loginWithEmail(email, password) {
        try {
            return await app_1.default.auth().signInWithEmailAndPassword(email, password);
        }
        catch (err) {
            let errorMessage;
            switch (err.code) {
                case "auth/invalid-email":
                    errorMessage = "Invalid email address.";
                    break;
                case "auth/user-disabled":
                    errorMessage = "User is disabled.";
                    break;
                case "auth/user-not-found":
                    errorMessage = "User doesn't exist.";
                    break;
                case "auth/wrong-password":
                    errorMessage = "Password is incorrect.";
                    break;
                default:
                    errorMessage = "Something went wrong during login.";
            }
            throw Error(errorMessage);
        }
    }
    async signInWithCustomToken(token) {
        try {
            return await app_1.default.auth().signInWithCustomToken(token);
        }
        catch (err) {
            throw Error(err.message || "Something went wrong.");
        }
    }
    async currentUser() {
        const existing = app_1.default.auth().currentUser;
        if (existing) {
            return existing;
        }
        return new Promise((resolve, reject) => {
            try {
                const unsubscribe = app_1.default.auth().onAuthStateChanged((user) => {
                    unsubscribe();
                    resolve(user);
                });
            }
            catch (err) {
                reject(new Error(err.message || "Something went wrong during user login status check."));
            }
        });
    }
    async getIdToken(forceRefresh) {
        try {
            const currentUser = await this.currentUser();
            if (currentUser) {
                return await currentUser.getIdToken(forceRefresh);
            }
            return null;
        }
        catch (err) {
            throw Error(err.message || "Something went wrong during token refetch.");
        }
    }
    async signOut() {
        try {
            return await app_1.default.auth().signOut();
        }
        catch (err) {
            throw Error(err.message || "Something went wrong during signOut.");
        }
    }
    async onAuthStateChanged(callback) {
        app_1.default.auth().onAuthStateChanged(callback);
    }
}
exports.FirebaseAuthService = FirebaseAuthService;
//# sourceMappingURL=FirebaseAuthService.js.map